module.exports = __webpack_public_path__ + "0776d9c072331a6c40b93455de2ccc47.svg";